<div class="page-layout carded left-sidenav toolbar-fixed-layout">
    <mat-sidenav-container>
        <!-- CENTER -->
        <div class="center flex flex-row" style="background: red">
            <!-- CONTENT CARD -->

            <div class="content-card mat-white-bg flex flex-col full-grow-no-shrink-no-basis">

                <div class="p-lr-30">
                    <h1 class="m-t-30">Withholding Tax Rates( from {{info.country1.name}} to {{info.country2.name}}
                        ) </h1>
                    <div class="note">
                        <div>Use the <a (click)="goWhtMinimizer()">withholding tax minimizer </a> to identify structures
                            to reduce
                            withholding taxes on cross border payment transactions.
                        </div>
                        <div>Use the <a (click)="goTransactionCalculator()">transaction calculator</a> to calculate the
                            total tax
                            cost on cross border payment transactions taking into account both local taxes and
                            withholding taxes.
                        </div>
                    </div>
                    <form class="m-t-20 flex flex-row" (keydown.enter)="$event.preventDefault()"
                          [formGroup]="inputForm">
                        <mat-form-field appearance="outline" class="m-r-20 flex-0-0-200px"
                                        *ngIf="availablePercentage">
                            <mat-label>Hoding Percentage (%)</mat-label>
                            <mat-select formControlName="holdingPercentage">
                                <mat-option *ngFor="let percentage of availablePercentage" [value]="percentage">
                                    {{percentage}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>


                        <mat-form-field appearance="outline" class="flex-0-0-200px" *ngIf="availablePeriods">
                            <mat-label>Hoding Period (month)</mat-label>
                            <mat-select formControlName="holdingPeriod">
                                <mat-option *ngFor="let period of availablePeriods" [value]="period">
                                    {{period}} months
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </form>
                </div>

                <div class="content pos-relative m-lr-30 m-b-30 m-t-20 full-grow-no-shrink-no-basis">
                    <div class="keno-grid-container">
                        <particle-virtual-grid [sourceKey]="sourceKey"
                                               [invalidateSubject]="invalidateSubject"
                                               sortFieldKey="Title"
                                               [pageSize]="300"
                                               (valueChanged)="onGridCellValueChange($event)">
                        </particle-virtual-grid>
                    </div>
                </div>
            </div>
        </div>
    </mat-sidenav-container>
</div>

